export const CONFIG = {
  // API_URL: process.env.REACT_APP_BE_URL || 'http://localhost:7121',
  API_URL: process.env.REACT_APP_BE_URL || 'https://dashout-backend-dev.azurewebsites.net',
};
